import { useAppSelector } from '@store';
import { ApplicationType } from '../../../hoc/new-application/types';
import ExpandableRow from './expandable-row';
import ExpandableRowContent from './expandable-row-content';
import { CustomerType, RiskScoringTypes } from '../../../hoc/customers/types';
import { AmlComponentProps } from './types';

const Products = ({
  expandedRows,
  setExpandedRows,
  values,
  // onSend,
  // onDelete,
  isEditable,
  type,
}: AmlComponentProps) => {
  const { productsCorporate, productsIndividual } = useAppSelector(
    (state) => state.customersDictionaries,
  );

  const products =
    type === CustomerType.CORPORATE || type === ApplicationType.CORPORATE
      ? productsCorporate
      : productsIndividual;

  return (
    <ExpandableRow
      name={RiskScoringTypes.PRODUCTS}
      title="Products"
      expandedRows={expandedRows}
      setExpandedRows={setExpandedRows}
      totalRisk={values?.productsRiskTotal as number}
      // comments={[]}
      // onSend={onSend}
      // onDelete={onDelete}
    >
      {values?.productsRiskItems?.map((item) => (
        <ExpandableRowContent
          key={item.id}
          value={
            products?.find((product) => product.value === item.id)
              ?.name as string
          }
          risk={
            item.value?.toString() !== 'null' &&
            item.value?.toString() !== 'undefined'
              ? item.value.toString()
              : '-'
          }
          name={products?.find((product) => product.value === item.id)?.name}
          isEditable={isEditable}
        />
      ))}
    </ExpandableRow>
  );
};

export default Products;
